import { render, staticRenderFns } from "./transactionInfo.vue?vue&type=template&id=0c88f46a"
import script from "./transactionInfo.vue?vue&type=script&lang=js"
export * from "./transactionInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports